<template>
  <div class="filter-panel-container" :class="{ closed }">
    <div class="filter-panel">
      <div class="filter-panel-header">
        <p>Select group to include in your report</p>
      </div>

      <div class="filter-panel-content">
        <div class="filter-group">
          <p>Questionnaire report</p>
          <dropdown
            label="Select report"
            :options="reportOptions"
            v-model="report"
          />
        </div>
      </div>

      <div class="filter-panel-border"></div>

      <div class="filter-panel-footer">
        <button @click="generateReport">
          <div>
            <p>generate report</p>
            <div class="generate-report-ico">
              <img src="@/assets/images/generate-report.svg" alt="Generate Report">
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown';
import { http } from '@/plugins/HttpPlugin';

async function getReportList() {
  let response;
  const url = '/reporting/survey';

  try {
    response = await http.get(url);
  } catch ({ response }) {
    throw response;
  }

  return response.data;
}

export default {
  name: 'FilterPanel',
  components: { Dropdown },

  data() {
    return {
      reports: [],
      report: null,
      closed: false,
    };
  },

  computed: {
    reportOptions() {
      return this.reports.map(report => ({
        key: report.id,
        label: report.name,
      }));
    },
  },

  methods: {
    generateReport() {
      if (this.closed === false) {
        // Emit the generate event and slide in the panel.
        this.$emit('generate', {
          report: this.report,
        });

        this.closed = true;
      } else {
        this.closed = false;
      }
    },
  },

  mounted() {
    getReportList().then(reports => (this.reports = reports));
  },
};
</script>

<style lang="scss" scoped>
.filter-panel-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 999999999;

  &.closed {
    background-color: transparent;
    pointer-events: none;

    .filter-panel {
      left: -430px;

      .filter-panel-footer button {
        pointer-events: all;
        right: -60px;
      }
    }
  }

  .filter-panel {
    position: fixed;
    top: 50%;
    left: 0;
    min-width: 450px;
    min-height: 75vh;
    display: grid;
    grid-template-columns: 1fr 20px;
    grid-template-rows: 50px 1fr 80px;
    grid-template-areas:
      'header header'
      'content border'
      'footer footer';
    background-color: #f3f3f3;
    transform: translateY(-50%);
    border-top-right-radius: 20px;
    transition: left 500ms ease-in-out;

    .filter-panel-header {
      grid-area: header;
      display: flex;
      align-items: center;
      background-color: #404142;
      padding: 0 25px;
      color: white;
      font-size: 15px;
      border-top-right-radius: 20px;
    }

    .filter-panel-content {
      grid-area: content;
      padding: 20px 25px;

      .filter-group {
        > p {
          color: #1381a2;
          font-size: 15px;
          margin: 0 0 10px;
        }
      }
    }

    .filter-panel-border {
      grid-area: border;
      background-image: url('../../assets/images/rainbow-reports.jpg');
      background-size: cover;
    }

    .filter-panel-footer {
      position: relative;
      grid-area: footer;
      background-color: #cde1e8;

      button {
        position: absolute;
        top: 0;
        right: -40px;
        border: none;
        color: white;
        height: 100%;
        min-width: 285px;
        padding: 8px;
        background-color: #cde1e8;
        border-radius: 0 1000px 1000px 0;
        cursor: pointer;

        > div {
          display: flex;
          align-items: center;
          background-color: #3986a3;
          border-radius: 1000px;
          padding: 2px 2px 2px 30px;
          height: 100%;

          p {
            margin: 0;
            flex: 1;
            text-align: center;
            font-size: 18px;
          }

          // Temporary class until we get the icon.
          .generate-report-ico {
            position: relative;
            border-radius: 100%;
            height: 60px;
            width: 60px;
            background-color: white;

            img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 60%;
            }
          }
        }
      }
    }
  }
}
</style>
